import { Link, useNavigate } from 'react-router-dom'

import HeaderSearch from '../components/common/headerSearch'
// import Icons from '../components/common/icons'
import { useAuthStore } from '../store/authStore'
import { useDomainManageStore } from '../store/domainManageStore'
import { useAccreditationFilterStore } from '../store/filterSore/accreditationStore'
import { useAdminUserFilterStore } from '../store/filterSore/adminUserStore'
import { useAssessorFilterStore } from '../store/filterSore/assessorStore'
import { useClearFilter } from '../store/filterSore/clearStore'
import { logoutUser } from '../apis/common.apis'
import { useOrganisationFilterStore } from '../store/filterSore/OrganisationStore'
import { useLayoutStore } from '../store/layoutStore'
import HeaderMenu from './headerMenu'
import HeaderTab from './headerTab'
import ResponsiveHeader from './responsiveHeader'

const HeaderTop = () => {
  const { layoutType } = useLayoutStore()
  const handleClear = useClearFilter()
  const navigate = useNavigate()

  const {
    clearAuthenticated,
    userData,
    // impersonating,
    setImpersonating,
    setActualUser,
  } = useAuthStore()

  const handleLogout = async () => {
    try {
      await logoutUser()
    } catch (err) {
      console.error(err)
    }
    useAdminUserFilterStore.getState().resetStore()
    useAssessorFilterStore.getState().resetStore()
    useOrganisationFilterStore.getState().resetStore()
    useAccreditationFilterStore.getState().resetStore()

    setActualUser({})
    setImpersonating(false)
    localStorage.clear()
    handleClear()
    localStorage.setItem('shouldReload', 'false')
    clearAuthenticated()

    const roleName = userData?.role?.name?.toLowerCase()
    if (roleName && ['admin', 'indianadmin', 'manager'].includes(roleName)) {
      navigate('/backoffice/login')
    } else {
      navigate(`/login`)
    }
  }
  const { domainType } = useDomainManageStore()
  const handleReturnPath = () => {
    if (domainType === 'Organisation') {
      return '/myorganisation/profile'
    } else if (domainType === 'Assessor') {
      return '/assessors'
    } else {
      return '/admin-user'
    }
  }
  return (
    <div className="header-height fixed w-full top-0 left-0 z-30 flex items-center justify-between bg-white border-formBorder border-b pe-5">
      <div className="ps-5 flex justify-between">
        <Link to={handleReturnPath()}>
          <div className="flex items-center gap-2 xl:max-w-[200px] 2xl:max-w-[200px] logo-width">
            <img className=" h-auto w-full" src="/images/login-logo.png" />
          </div>
        </Link>
      </div>
      {layoutType === 'headerNav' && <HeaderTab />}
      <div className="flex gap-1 xl:gap-2 items-center">
        <div className="md:block hidden">
          {(userData?.role?.name == 'indianadmin' ||
            userData?.role?.name == 'user') && <HeaderSearch />}
        </div>
        {/* <div className="size-8 md:size-6 xl:size-8  flex items-center group  justify-center border border-grey-mediumAlt text-blackAlt  cursor-pointer rounded-sm xl:rounded-md">
          <Icons
            className="transition duration-700 stroke-2 size-4  group-hover:rotate-180"
            name="settings-icon"
          />
        </div>
        <div className="size-8 md:size-6 xl:size-8  group flex items-center justify-center relative border border-grey-mediumAlt text-grey-strong cursor-pointer rounded-sm xl:rounded-md">
          <Icons name="notify-icon" className="size-4 origin-top" />
          <span className="absolute text-white text-xxs bg-notificationClr px-1.5 z-10 -top-2 right-0 translate-x-1/2 rounded-full">
            9
          </span>
        </div> */}
        <HeaderMenu userData={userData} handleLogout={handleLogout} />
      </div>
      {layoutType === 'sideNav' && (
        <div className="md:hidden fixed top-[56px] bg-white block w-full">
          <ResponsiveHeader />
        </div>
      )}
    </div>
  )
}

export default HeaderTop
